<template>
  <div class="right-sidebar" :class="{ 'right-sidebar__sticky': isSticky }">
    <component
      v-for="(item, key) in itemsByBreakpoints"
      :is="loadComponent[item.type]"
      :key="key"
      :id="item._id"
      :item="item"
    />
    <div class="ad_slot rectangle_wrapper">
      <div id="rectangle" class="ad_wrapper rectangle"></div>
    </div>
  </div>
</template>

<script setup>
import { useBreakpoint } from '@/composables/useBreakpoints'
import { computed, defineAsyncComponent, markRaw, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSectionsStore } from '@/stores/section'

const sectionsStore = useSectionsStore()
const { itemsBlockPage } = storeToRefs(sectionsStore)
const { isDesktop } = useBreakpoint()

const loadComponent = ref({
  'GROUPED-NEWS': markRaw(
    defineAsyncComponent(() => import('@/components/sidebar/CategoryNewsBox.vue'))
  ),
  'SINGLE-NEWS': markRaw(
    defineAsyncComponent(() => import('@/components/sidebar/CategoryBoxArticle.vue'))
  ),
  WEATHER: markRaw(defineAsyncComponent(() => import('@/components/weather/WeatherSidebar.vue'))),
  'STOCK-QUOTES-INDEX': markRaw(
    defineAsyncComponent(() => import('@/components/market/MarketContent.vue'))
  ),
  'STOCK-QUOTES-CURRENCY': markRaw(
    defineAsyncComponent(() => import('@/components/market/MarketContent.vue'))
  ),
  'STOCK-MOBILE-SLIDER': markRaw(
    defineAsyncComponent(() => import('@/components/market/MarketContentMobile.vue'))
  ),
  'CUSTOM-BOX': markRaw(
    defineAsyncComponent(() => import('@/components/sidebar/CategoryBoxArticle.vue'))
  ),
  'VIDEO-BOX': markRaw(
    defineAsyncComponent(() => import('@/components/sidebar/CategoryBoxArticle.vue'))
  ),
  'LATEST-MULTI': markRaw(defineAsyncComponent(() => import('@/components/boxes/NewsBox.vue')))
})

const props = defineProps({
  categorySidebarId: {
    type: [Number, String],
    default: ''
  },
  isSticky: {
    type: Boolean,
    default: false
  }
})

const items = computed(() => itemsBlockPage.value[props.categorySidebarId]?.items)

const filteredItems = computed(() => {
  if (items.value) {
    const itemsOnlyStock = items.value?.filter((el) => el.type.includes('STOCK'))
    const itemsWithoutStock = items.value?.filter((el) => !el.type.includes('STOCK'))
    return [
      ...itemsWithoutStock,
      { type: 'STOCK-MOBILE-SLIDER', items: itemsOnlyStock, _id: 'STOCK-MOBILE-SLIDER' }
    ]
  }
  return []
})

const itemsByBreakpoints = computed(() => (isDesktop.value ? items.value : filteredItems.value))
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/modules/module-right-sidebar.scss';
</style>
